import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import Basket from "../components/basket";
import { selectBasket, selectDefaultReducer } from "../redux/default/selectors";

const BasketContainer = () => {
  const dispatch = useDispatch();

  const {
    open,
    products,
    addingProductIds,
    removingProductIds,
    downloading,
  } = useSelector(selectBasket);

  const {
    downloadPaths,
    availableDownloadOptions,
    translations,
  } = useSelector(selectDefaultReducer);

  const disabledDownloadAll =
    products.length === 0 || !availableDownloadOptions.all;
  const disabledDropup =
    products.length === 0 ||
    (!availableDownloadOptions.specs && !availableDownloadOptions.revit);
  const disabledDownload = disabledDropup;
  
  const onOpenClick = () => dispatch(Action.openBasket());
  const onCloseClick = () => dispatch(Action.closeBasket());
  const onRemoveClick = (productId) => dispatch(Action.removeProduct(productId));
  const onDownloadClick = () => dispatch(Action.basketDownloadRequested());
  const onCloseDownloadNotificationClick = () => dispatch(Action.closeBasketDownloadNotification());

  return (
    <Basket
      open={open}
      products={products}
      downloadPaths={downloadPaths}
      availableDownloadOptions={availableDownloadOptions}
      disabledDownloadAll={disabledDownloadAll}
      disabledDropup={disabledDropup}
      disabledDownload={disabledDownload}
      addingProductIds={addingProductIds}
      removingProductIds={removingProductIds}
      downloading={downloading}
      translations={translations}
      onOpenClick={onOpenClick}
      onCloseClick={onCloseClick}
      onRemoveClick={onRemoveClick}
      onDownloadClick={onDownloadClick}
      onCloseDownloadNotificationClick={onCloseDownloadNotificationClick}
    />
  )
}

export default BasketContainer;